import { useState } from "react"
import { createFileRoute } from "@tanstack/react-router"
import { OverviewPage } from "~/components/design-system/pages"
import BuysList from "~/components/noos-supply-plan/BuysList"
import { useHoveredBuyCoverage } from "~/components/noos-supply-plan/useHoveredBuyCoverage"
import { useNoosSupplyPlanDetailContext } from "~/context/NoosSupplyPlanDetailProvider"
import SupplyPlanTiles from "~/components/noos-supply-plan/SupplyPlanTiles"
import NoosTriggerSummaryCard from "~/components/noos-supply-plan/NoosTriggerSummaryCard"
import { useNoosTriggerOverview } from "~/components/noos-supply-plan/useNoosTriggers"
import AvailabilityByCategorySection from "~/components/noos-supply-plan/AvailabilityByCategorySection"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/overview",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("NOOS Supply Plan Detail - Overview")
  const { supplyPlan } = useNoosSupplyPlanDetailContext()
  const [hoveredBuyId, setHoveredBuyId] = useState<number | undefined>()
  const hoveredCoverage = useHoveredBuyCoverage(hoveredBuyId)
  // Once for both cards, so the tiles and the trigger summary count the same rows.
  const triggerOverview = useNoosTriggerOverview()

  return (
    <OverviewPage
      contentClassName="gap-6"
      inspector={<SupplyPlanTiles overview={triggerOverview} />}
      inspectorWidth="sm"
    >
      <NoosTriggerSummaryCard overview={triggerOverview} />
      <BuysList supplyPlanId={supplyPlan.id} onHoverBuy={setHoveredBuyId} />
      <AvailabilityByCategorySection hoveredCoverage={hoveredCoverage} />
    </OverviewPage>
  )
}
